import styled from 'styled-components';

import { CommentsLink } from 'components/ExchangeDiscussion/styles';
import {
  colorGrey400,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
  mediaQueryMobileMin,
} from 'styles';
import { H2, Paragraph } from 'components/Typography';

export const ButtonsWrapper = styled.div`
  margin: 0 0 16px;
  display: flex;
  overflow: auto;
  padding-right: 32px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 6px;
    overflow: visible;
  }
`;

export const RelativeWrapper = styled.div`
  overflow: hidden;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 40px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  @media all and ${mediaQueryMobileMin} {
    width: auto;
    margin-top: 6px;
    overflow: visible;

    &:after {
      display: none;
    }
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media all and ${mediaQueryMobileLargeMin} {
    justify-content: space-between;
    flex-direction: row;
  }
`;
export const Title = styled(H2)`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;
export const Wrapper = styled.section`
  width: 100%;
  padding: 16px;
  margin-bottom: 16px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
`;

export const CitiesWrapper = styled.div`
  position: relative;
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;
  margin-bottom: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-bottom: 0;
  }
`;
export const TableFooter = styled.div`
  display: flex;
  margin-top: 16px;
  width: 100%;
  flex-direction: column-reverse;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const TableFooterLink = styled(CommentsLink)`
  svg {
    margin-left: 4px;
    align-self: center;
  }
`;
